import { request } from "utils";

export type RequestInfoType = {};

export type RequestListInfoType = RequestInfoType[];

const url = "request/list";

export async function callGetRequestList(params): Promise<RequestListInfoType> {
  console.log("callGetRequestList params", params);
  const res = await request.get(url, {
    ...(params || {}),
  });
  return res;
}

export async function callGetPaginatedRequestList(
  params = {}
): Promise<RequestListInfoType> {
  const res = await callGetRequestList({
    is_paginate: 1,
    ...params,
  });
  return res;
}

export default callGetRequestList;
